import React from "react";
import { Col, Card } from "react-bootstrap";
import { Speakers, FormattedEventDate, WatchButton, RegisterButtonClick } from "./EventsPanelParts";
import { AddEventToCalendar } from "./AddEventToCalendar";
import { EventsPill, populateEventPills } from "./commom/EventsPill";

export default function FutureEventCard(props) {
  const pillData = populateEventPills({ ...props, excludeLanguages: false });
  return (
    <Col className="px-2 pb-3 d-flex" lg="4" sm="6" xs="12" style={props.containerStyle}>
      <Card className="shadow w-100">
        <Card.Header className="border-0">
          <Speakers speakers={props.slots?.[0]?.speakers} />
        </Card.Header>
        <Card.Body>
          <Card.Title className="font-weight-lighter h4-imp my-0">{props.eventName}</Card.Title>
        </Card.Body>
        <Card.Footer className="border-top-0 pb-0 mt-1 mb-1 mr-3">
          <EventsPill pills={pillData} />
        </Card.Footer>
        <Card.Footer className="border-top-0 d-flex flex-row pt-0">
          <Card.Text className="h6 mb-1 mr-2 mt-auto">
            <FormattedEventDate {...props.slots?.[0]} displayTime />
          </Card.Text>
          {props.slots?.[0]?.locationURL ? <AddEventToCalendar eventData={props} slotData={props.slots?.[0]} /> : null}
        </Card.Footer>
        <Card.Footer className="clearfix border-1">
          {props.isFutureEvent ? (
            <RegisterButtonClick locationURL={props.slots?.[0]?.locationURL} eventId={props.eventId} />
          ) : (
            <WatchButton {...props} />
          )}
        </Card.Footer>
      </Card>
    </Col>
  );
}
